// A sidebar's open state and its group and subheader expansion, saved in this browser under
// one key per zone. Storage can be unavailable or hold anything, so reads validate and both
// directions swallow errors; the sidebar then falls back to its defaults.

export type SidebarSnapshot = {
  open?: boolean;
  /** Expanded group headers, by label. */
  groups?: string[];
  /** Open subheaders, as `${group}/${subheader}`. */
  subheaders?: string[];
};

const PREFIX = "xlogs.sidebar.";

function strings(value: unknown): string[] | undefined {
  return Array.isArray(value) && value.every((v) => typeof v === "string") ? value : undefined;
}

export function readSidebarSnapshot(key: string): SidebarSnapshot | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Record<string, unknown> | null;
    return {
      open: typeof parsed?.open === "boolean" ? parsed.open : undefined,
      groups: strings(parsed?.groups),
      subheaders: strings(parsed?.subheaders),
    };
  } catch {
    return null;
  }
}

export function writeSidebarSnapshot(key: string, patch: SidebarSnapshot) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ ...readSidebarSnapshot(key), ...patch }));
  } catch {
    // Storage unavailable; the sidebar keeps working without it.
  }
}
